import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

export type StandardCardProps = {
  title?: string | ReactNode;
  description?: string;
  children: ReactNode;
  className?: string;
  headerClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  contentClassName?: string;
  onClick?: () => void;
  hoverable?: boolean;
  showHeader?: boolean;
  headerAction?: ReactNode;
};

export function StandardCard({
  title,
  description,
  children,
  className,
  headerClassName,
  titleClassName,
  descriptionClassName,
  contentClassName,
  onClick,
  hoverable = false,
  showHeader = true,
  headerAction,
}: StandardCardProps) {
  const defaultCardStyles = 'border-border';
  const defaultTitleStyles = 'font-heading';
  const hoverStyles = hoverable ? 'cursor-pointer transition-shadow hover:shadow-md' : '';
  const clickableStyles = onClick ? 'cursor-pointer' : '';

  return (
    <Card className={cn(defaultCardStyles, hoverStyles, clickableStyles, className)} onClick={onClick}>
      {showHeader && (title || description || headerAction) && (
        <CardHeader className={cn(headerClassName)}>
          <div className="flex items-start justify-between">
            <div className="flex-1">
              {title && <CardTitle className={cn(defaultTitleStyles, titleClassName)}>{title}</CardTitle>}
              {description && (
                <p className={cn('text-muted-foreground mt-2 text-sm', descriptionClassName)}>{description}</p>
              )}
            </div>
            {headerAction && <div className="ml-4">{headerAction}</div>}
          </div>
        </CardHeader>
      )}

      <CardContent className={cn(contentClassName)}>{children}</CardContent>
    </Card>
  );
}
